module.exports = __webpack_public_path__ + "img/editicon.f68647e4.svg";